import { render, staticRenderFns } from "./SubTax.vue?vue&type=template&id=ee5c8204"
import script from "./SubTax.vue?vue&type=script&lang=js"
export * from "./SubTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports